import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SurchargeMethods, TypeOptions } from './activity-detail.enums';
import { SurchargeMethod } from './activity-detail.interface';

@Injectable({
	providedIn: 'root'
})
export class ActivityDetailService {

	constructor(public translate: TranslateService) { }

	getSurchargeOptions(option: TypeOptions): SurchargeMethod[] {
		return [
			{
				name: this.translate.instant('Core.Enums.ActivitySurchargeMethod.NOSURCHARGE'),
				id: SurchargeMethods.NOSURCHARGE,
				option: 'default'
			},
			{
				name: this.translate.instant('Core.Enums.ActivitySurchargeMethod.FIXEDAMOUNT'),
				id: SurchargeMethods.FIXEDAMOUNT,
				option: 'default'
			},
			{
				name: this.translate.instant('Core.Enums.ActivitySurchargeMethod.PERUNIT'),
				id: SurchargeMethods.PERUNIT,
				option: TypeOptions.EXPENSE
			},
			{
				name: this.translate.instant('Onvio.Setup.Activities.Detail.SurchargeMethodHourly'),
				id: SurchargeMethods.HOURLY,
				option: TypeOptions.TIME
			},
			{
				name: this.translate.instant('Core.Enums.ActivitySurchargeMethod.PERCENT'),
				id: SurchargeMethods.PERCENT,
				option: 'default'
			}
		].filter(el => el.option === 'default' || el.option === option);
	}
}
